import { OfficeActiveLocations } from '@/types';
import { POLITICAL_DISTRICT_BY_ADMUNIT_ID } from './politicalDistrictByAdmunitId';

const byDe = (a: string, b: string) => a.localeCompare(b, 'de', { numeric: true });

const normalizeName = (value: string) => value.trim().toLocaleLowerCase('de');

const viennaDistrictByName = new Map<string, string>([
  ['fünfhaus', POLITICAL_DISTRICT_BY_ADMUNIT_ID['AT.915']],
]);

for (const title of Object.values(POLITICAL_DISTRICT_BY_ADMUNIT_ID)) {
  const comma = title.lastIndexOf(',');
  if (comma !== -1) viennaDistrictByName.set(normalizeName(title.slice(comma + 1)), title);
}

const districtFromMunicipalityCode = (code?: string | null) => {
  if (!code?.startsWith('AT.')) return undefined;
  const digits = code.slice(3);
  if (!/^\d{3,}$/.test(digits)) return undefined;
  return POLITICAL_DISTRICT_BY_ADMUNIT_ID[`AT.${digits.slice(0, 3)}`];
};

const districtFromPlace = (place?: string | null) => {
  const viennaPart = place?.match(/^Wien\s*,\s*(.+)$/i)?.[1];
  if (!viennaPart) return undefined;
  return viennaDistrictByName.get(normalizeName(viennaPart));
};

export const formatOfficeActiveLocations = (activeLocations?: OfficeActiveLocations | null) => {
  if (!activeLocations) return null;

  const names = new Set<string>();

  for (const municipality of activeLocations.municipalities ?? []) {
    const district = districtFromMunicipalityCode(municipality?.code);
    if (district) names.add(district);
  }

  for (const place of activeLocations.places ?? []) {
    const district = districtFromPlace(place);
    if (district) names.add(district);
  }

  if (!names.size) return null;

  return [...names].sort(byDe).join(', ');
};
